import { useTheme } from '@mui/material';
import Typography from '@mui/material/Typography';

import Button from '@/components/Button';
import Modal from '@/components/Modals/Modal';

interface AnyOrdersProps {
  isOpen: boolean;
  onClose: () => void;
  message?: string;
}

const AnyOrders = ({ isOpen, onClose, message }: AnyOrdersProps) => {
  const theme = useTheme();
  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        title="No se encontraron órdenes"
        actions={
          <Button
            variant="contained"
            onClick={() => {
              onClose();
            }}
          >
            Cerrar
          </Button>
        }
      >
        <Typography
          variant="body1"
          sx={{ padding: '1rem', color: theme.palette.grey[500], textAlign: 'center' }}
        >
          {message || 'No tienes órdenes de venta para el día de hoy'}
        </Typography>
      </Modal>
    </>
  );
};

export default AnyOrders;
